/* ============================================================
   Vintage Luxe Up — Header behavior
   - Sticky transparent → cream after 80px scroll
   - --header-height CSS variable for layout offsets
   - Mobile drawer open/close (aria-hidden + body scroll lock)
   ============================================================ */

(function () {
  'use strict';

  // ---- Sticky transparent → solid ----
  function initStickyHeader() {
    const headers = document.querySelectorAll('[data-vlu-sticky]');
    if (!headers.length) return;

    const THRESHOLD = 80;
    let scrolled = window.scrollY > THRESHOLD;

    function setHeaderHeight() {
      headers.forEach((h) => {
        document.documentElement.style.setProperty('--header-height', h.offsetHeight + 'px');
      });
    }

    function applyScrolledClass() {
      const isScrolled = window.scrollY > THRESHOLD;
      if (isScrolled === scrolled) return;
      scrolled = isScrolled;
      headers.forEach((h) => h.classList.toggle('vlu-header--scrolled', isScrolled));
    }

    setHeaderHeight();
    applyScrolledClass();

    window.addEventListener('scroll', applyScrolledClass, { passive: true });
    window.addEventListener('resize', setHeaderHeight, { passive: true });
  }

  // ---- Mobile drawer ----
  function initMobileDrawer() {
    const drawer = document.getElementById('vlu-mobile-drawer');
    const openBtn = document.querySelector('[data-vlu-drawer-open]');
    if (!drawer || !openBtn) return;

    const closeBtns = drawer.querySelectorAll('[data-vlu-drawer-close]');

    function isOpen() {
      return drawer.getAttribute('aria-hidden') === 'false';
    }

    function open() {
      drawer.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('vlu-drawer-open');
      // Move focus to close button for keyboard users
      const closeBtn = drawer.querySelector('[data-vlu-drawer-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('vlu-drawer-open');
      openBtn.focus();
    }

    openBtn.addEventListener('click', open);
    closeBtns.forEach((b) => b.addEventListener('click', close));

    // Click on backdrop (drawer itself, not its panel) closes
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) close();
    });

    // Escape closes
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen()) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initStickyHeader();
      initMobileDrawer();
    });
  } else {
    initStickyHeader();
    initMobileDrawer();
  }
})();
